import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector:'app-service-details',
  templateUrl:'./service-details.component.html',
  styleUrls:['./service-details.component.scss']
})
export class ServiceDetailsComponent implements OnInit {


service:any;

serviceId:any;


  imageUrl = environment.apiUrl;
  showViewer: boolean = false;
  imageList: any[] = [];
  selectedIndex: number = 0;

  isDescriptionExpanded: boolean = false;
  activeGalleryFilter: string = 'All';
  galleryFilters: string[] = ['All', 'Wedding', 'Reception', 'Bride', 'Groom', 'Candid', 'Traditional'];
  filteredPortfolio: any[] = [];
  categories: any[] = [];
categoryName: string = '';

  get emptyPreviewSlots(): number[] {
      const needed = Math.max(0, 4 - (this.imageList.length - 1));
      return Array(needed).fill(0);
  }

  get videoList(): any[] {
      return this.portfolioItems.filter((item: any) => item.media_type === 'video');
  }

  portfolioItems: any[] = [];

  mockVendor = {
    name: 'Thirukulam Weddings',
    rating: 4.8,
    reviewCount: 124,
    bookingCount: 0,
    isPremium: true,
    isVerified: true
  };

  mockReviews = [
    { name: 'Priya Rajan', rating: 5, date: 'October 2025', text: 'Absolutely amazing service! The photos came out beautifully and the team was so professional.', avatar: 'https://i.pravatar.cc/150?u=priya' },
    { name: 'Karthik & Sneha', rating: 5, date: 'August 2025', text: 'We booked them for our reception and they exceeded our expectations. Highly recommended!', avatar: 'https://i.pravatar.cc/150?u=karthik' },
    { name: 'Divya M', rating: 4, date: 'June 2025', text: 'Great experience overall. Delivery was slightly delayed but the quality made up for it.', avatar: 'https://i.pravatar.cc/150?u=divya' }
  ];

  mockRelatedServices = [
    { title: 'Cinematic Videography', price: 45000, image: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?auto=format&fit=crop&w=600&q=80' },
    { title: 'Pre-Wedding Shoot', price: 25000, image: 'https://images.unsplash.com/photo-1583939000142-88fdfb5f1345?auto=format&fit=crop&w=600&q=80' },
    { title: 'Premium Album Design', price: 15000, image: 'https://images.unsplash.com/photo-1544928147-79a2dbc1f389?auto=format&fit=crop&w=600&q=80' }
  ];

  similarVendors: any[] = [];

constructor(
private route:ActivatedRoute,
private apiService:ApiServiceService,
private router:Router
){}




ngOnInit():void{


this.serviceId =
this.route.snapshot.paramMap.get('id');



this.getService();
this.getServicePortfolioImages();
this.getBookingCount();


}

openBookingCalendar(){

this.router.navigate(
[
'/wedding-services/booking-calendar',
this.serviceId
]
);

}





getService() {

    this.apiService
        .getServiceDetails(this.serviceId)
        .subscribe({

            next: (res) => {

                this.service = res.data;

                // Update vendor name
                if (
                    this.service.merchantId &&
                    this.service.merchantId.business_name
                ) {
                    this.mockVendor.name =
                        this.service.merchantId.business_name;
                }

                // Load other vendors from the same category
                this.getSimilarVendors();

            },

            error: (err: any) => {

                console.log(err);

            }

        });

}
getSimilarVendors() {

    if (!this.service?.category) {
        return;
    }

    const categoryId =
        typeof this.service.category === 'object'
            ? this.service.category._id
            : this.service.category;

    if (!categoryId) {
        return;
    }

    this.apiService
        .getMerchantsByCategory(categoryId)
        .subscribe({

            next: (res) => {

    const vendors = res.data || [];

    console.log(
  'VENDOR IMAGES:',
  vendors.map((vendor: any) => ({
    id: vendor._id,
    name: vendor.business_name,
    profile_pic: vendor.profile_pic
  }))
);

    const currentMerchantId =
        typeof this.service.merchantId === 'object'
            ? this.service.merchantId._id
            : this.service.merchantId;

    this.similarVendors = vendors.filter(
        (vendor: any) =>
            vendor._id !== currentMerchantId
    );

},

            error: (err) => {

                console.log(
                    'Similar Vendors Error:',
                    err
                );

                this.similarVendors = [];

            }

        });

}
getVendorImage(vendor: any): string {

  const imagePath = vendor?.profile_pic;

  if (!imagePath) {
    return 'assets/images/vendor-placeholder.jpg';
  }

  // Already a complete URL
  if (
    imagePath.startsWith('http://') ||
    imagePath.startsWith('https://')
  ) {
    return imagePath;
  }

  // Backend paths such as:
  // /auth/image/merchants/profile_pics/xxx.jpg
  if (imagePath.startsWith('/')) {
    return this.imageUrl + imagePath;
  }

  // Just in case backend returns backslashes
  const normalizedPath = imagePath.replace(/\\/g, '/');

  return this.imageUrl + '/' + normalizedPath;
}
// onVendorImageError(event: Event): void {

//   const img = event.target as HTMLImageElement;

//   img.src = 'assets/images/vendor-placeholder.jpg';

// }
openVendor(vendor: any) {

    this.router.navigate([
        '/wedding-services/merchant',
        vendor._id
    ]);

}
getBookingCount(){

  this.apiService
  .getServiceBookingCount(this.serviceId)
  .subscribe({

    next:(res)=>{

      this.mockVendor.bookingCount =
      res.bookingCount;

    },

    error:(err)=>{

      console.log(err);

    }

  });

}
openImage(media:any){


this.selectedIndex =
this.imageList.indexOf(media);


this.showViewer=true;


}
getServicePortfolioImages(){
  this.apiService.getServicePortfolio(this.serviceId).subscribe({
    next: (res) => {
      this.portfolioItems = res.data || [];
      this.imageList = this.portfolioItems.filter((item:any) => item.media_type === 'image');
      this.filteredPortfolio = this.imageList;
    },
    error: (err) => {
      console.log(err);
    }
  });
}

nextImage(){


if(this.selectedIndex < this.imageList.length-1){

this.selectedIndex++;

}


}




previousImage(){


if(this.selectedIndex > 0){

this.selectedIndex--;

}


}




closeViewer(){


this.showViewer=false;


}
openEnquiry(){

this.router.navigate(

[
'/wedding-services/service-enquiry',
this.serviceId
]

);

}

toggleDescription() {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
}

setGalleryFilter(filter: string) {
    this.activeGalleryFilter = filter;
    if (filter === 'All') {
        this.filteredPortfolio = this.imageList;
    } else {
        // Mock filtering logic by randomly sorting and picking a subset
        this.filteredPortfolio = this.imageList.filter(() => Math.random() > 0.3);
        if (this.filteredPortfolio.length === 0 && this.imageList.length > 0) {
            this.filteredPortfolio = [this.imageList[0]];
        }
    }
}

}